import { handleActions } from 'redux-actions';
import { setNotificationTemplates } from './actions';

const defaultState = [];

export const reducer = handleActions(
  {
    [setNotificationTemplates]: (state, action) => {
      const notificationTemplates = action.payload;
      return notificationTemplates;
    },
  },
  defaultState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/lib/dataLayer/notificationTemplates/reducer.js